import { render, staticRenderFns } from "./VisitaOrden.vue?vue&type=template&id=37b81f34"
import script from "./VisitaOrden.vue?vue&type=script&lang=js"
export * from "./VisitaOrden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports